import React from 'react';
import { makeStyles } from '@material-ui/core';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import clsx from 'clsx';
import { drawerWidth, drawerClosedWidth } from '../../Config/constants';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import PDFDialog from '../Shared/Dialogs/PDFDialog';
import { connect } from 'react-redux';
import { CircleHelp, Cog, Hammer, House, Recycle, RefreshCcw, Scale, Users } from 'lucide-react';

export const NavDrawer = (props) => {
    const classes = useStyles();
    let history = useHistory();
    let location = useLocation();
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(location.pathname);
    const [helpFilesDialogOpen, setHelpFilesDialogOpen] = React.useState(false);

    const { t } = useTranslation();

    const toggleDrawer = () => {
        setOpen(!open);
    }

    const handleRedirect = (link) => {

        if (link === "/help") {
            setHelpFilesDialogOpen(true)
        } else {
            history.push(link);
            setPage(link);
        }
    }

    history.listen(event => {

        if (!event.pathname.includes('login')) {
            props.actions.setCurrentURL(event.pathname)
        }
        if (event.pathname.includes('dashboard')) {
            props.actions.setSmart("PRODUCTIVITY")
        }
        else {
            props.actions.setSmart("PRODUCTION")
        }

        if (event.pathname.includes("/workstation") || event.pathname.includes("/order") || event.pathname.includes("/qualitychecks") || event.pathname.includes("/sampling") || event.pathname.includes("/productionstate")) {
            if (event.pathname.includes("/workstation")) {
                props.actions.setSelectedZone(null)
            }
            if (!props.nav.showActiveLines) {
                props.actions.setShowActiveLines(true)
            }
        }
        else {
            if (props.nav.showActiveLines) {
                props.actions.setShowActiveLines(false)
            }
        }

        if (event.pathname.includes("/recycle")) {
            if (!props.nav.showActiveRecyclingLines) {
                props.actions.setShowActiveRecyclingLines(true)
            } else {

                props.actions.setShowActiveRecyclingLines(false)
            }
        } else {
            props.actions.setShowActiveRecyclingLines(false)
        }

        setPage(event.pathname);
    });

    return (
        <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}
        >
            <React.Fragment>
                <div className={classes.toolbar}>
                    <IconButton onClick={toggleDrawer}>
                        <img className={classes.menuIcon} alt="menu" src={process.env.PUBLIC_URL + '/img/menu.svg'}></img>
                    </IconButton>
                </div>
                <Divider />
                <List className={classes.list}>
                    <ListItem className={clsx({ [classes.activeList]: page === "/" })} style={{ paddingLeft: "13px" }} button key="workstations" onClick={() => handleRedirect("/")}>
                        <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page === "/" })}><House className={classes.navigationIcon} /></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page === "/" })} primary={t('Workstations')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    {(props.user.isAdministrator || props.user.isExtrusieOperator || props.user.isSchrijnwerkOperator) &&
                        <ListItem className={clsx({ [classes.activeList]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} style={{ paddingLeft: "13px" }} button key="overview" disabled={!props.workstation.selectedWorkstation} onClick={() => handleRedirect("/workstation")}>
                            <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} ><Cog className={classes.navigationIcon} /></ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} primary={t('Production')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>}
                    {(props.user.isAdministrator || props.user.isSchrijnwerkOperator) &&
                        <ListItem className={clsx({ [classes.activeList]: page.includes("/carpentryWorkstation") })} style={{ paddingLeft: "13px" }} button key="cerpentryoverview" disabled={props.workstation.selectedCarpentryWorkstationId === 0} onClick={() => handleRedirect("/carpentryWorkstation")}>
                            <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/carpentryWorkstation") })} ><Hammer className={classes.navigationIcon} /></ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page.includes("/carpentryWorkstation") })} primary={t('Carpentry')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>}
                    {(props.user.isAdministrator || props.user.isScrapOperator) &&
                        <ListItem className={clsx({ [classes.activeList]: page.includes("/recycle") || page.includes("/recyclinghistory") })} style={{ paddingLeft: "13px" }} button key="scrap" disabled={props.workstation.selectedRecyclingWorkstationId === 0} onClick={() => handleRedirect("/recycle")}>
                            <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/recycle") || page.includes("/recyclinghistory") })}><Recycle className={classes.navigationIcon} /></ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page.includes("/recycle") || page.includes("/recyclinghistory") })} primary={t('Recycle')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>}
                    {(props.user.isAdministrator || props.user.isExtrusieOperator || props.user.isScrapOperator) &&
                        <ListItem className={clsx({ [classes.activeList]: page === "/scale" })} style={{ paddingLeft: "13px" }} button key="scales" onClick={() => handleRedirect("/scale")}>
                            <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page === "/scale" })}><Scale className={classes.navigationIcon} /></ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page === "/scale" })} primary={t('Scales')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>}
                    {props.user.isAdministrator &&
                        <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "100" }} className={clsx({ [classes.activeList]: page.includes("/sync") })} button key="synchronisation" onClick={() => handleRedirect("/sync")}>
                            <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/sync") })}><RefreshCcw className={classes.navigationIcon} /></ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page.includes("/sync") })} primary={t('Synchronisation')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>}
                    {props.user.isAdministrator &&
                        <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "50" }} className={clsx({ [classes.activeList]: page.includes("/users") })} button key="gebruikers" onClick={() => handleRedirect("/users")}>
                            <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/users") })}><Users className={classes.navigationIcon} /></ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page.includes("/users") })} primary={t('Gebruikers')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>}
                    <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "0" }} button key="help" onClick={() => handleRedirect("/help")}>
                        <ListItemIcon className={classes.navigationIconContainer}><CircleHelp className={classes.navigationIcon} /></ListItemIcon>
                        <ListItemText primary={t('Help')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                </List>
                <PDFDialog {...props} dialogOpen={helpFilesDialogOpen} closeDialog={() => setHelpFilesDialogOpen(false)}></PDFDialog>
            </React.Fragment>
        </Drawer>
    )
}

const useStyles = makeStyles((theme) => ({
    spacer80: {
        height: '80px'
    },

    gridmargin: {
        paddingRight: "50px !important"
    },

    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    navButton: {
        textDecoration: 'none'
    },

    background: {
        height: '100vh',
        width: '100%'
    },

    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
    },
    drawerClose: {
        width: drawerClosedWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden'
    },

    activeList: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        }
    },

    activeText: {
        color: FlagstoneTheme.palette.secondary.main,
        '&:hover': {
            color: "white",
        }
    },
    activeIcon: {
        fill: "white",
    },
    activeHomeIcon: {
        stroke: "white"
    },
    activeProductionIcon: {
        fill: "white",
        stroke: "white",
        strokeWidth: "0.3px"
    },
    list: {
        height: "100%"
    },
    userIcon: {
        width: "30px",
        fontSize: '32px !important',
    },

    navigationIconContainer: {
        color: FlagstoneTheme.palette.text.primary,
    },

    activeIconContainer: {
        color: FlagstoneTheme.palette.text.light,
    },

    navigationIcon: {
        width: "24px",
        height: "24px",

        strokeWidth: "1.4px"
    },


}));

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(NavDrawer)